import { render, staticRenderFns } from "./VersionUpdatedNotificationBar.vue?vue&type=template&id=e971dacc&scoped=true"
import script from "./VersionUpdatedNotificationBar.vue?vue&type=script&lang=ts"
export * from "./VersionUpdatedNotificationBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e971dacc",
  null
  
)

export default component.exports